import { Component, OnInit, OnDestroy, HostListener, Renderer } from '@angular/core';
import { QuestionsService } from '../../services';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'my-question',
  template: require('./question.component.html'),
  styles: [require('./question.component.scss')]
})
export class QuestionComponent implements OnInit, OnDestroy {
  public question: any = {};
  public isReady = false;
  public quizReady = false;
  private subscription: ISubscription;
  public animateQuestion = true;
  public animateQuestionOut = false;
  public correctAnswer = false;
  public showResult = false;
  public resultsReady = false;
  public points = 0;
  public orientationErr: Boolean = false;
  @HostListener('window:resize', ['$event']) onResize(event) {
    let winWidth = event.target.innerWidth;
    let winheight = event.target.innerHeight;
    if (winWidth > winheight && winWidth < 1024) {
      this.orientationErr = true;
    }else{
      this.orientationErr = false;
    }
  }

  constructor(
    private questionsService: QuestionsService,
    private renderer: Renderer) {
    this.subscription = this.questionsService.data.subscribe( data => {
      let sub = this;
      this.showResult = false;
      let result: any = data;
      result = (result.length > 1 ? result[0] : result);
      setTimeout( () => {
        sub.question = result;
        sub.animateIn();
      }, 1000);
    });
  }

  next() {
    this.animateQuestionOut = true;
    if (this.question.order === 15) {
      this.getResults();
    }else {
      this.renderer.setElementClass(document.body, 'overflow-hide', true);
      this.questionsService.next();
    }
  }

  prev() {
    this.animateQuestion = false;
    this.questionsService.prev();
  }

  validateQuestion(status: boolean) {
    this.showResult = true;
    if ( status ) {
      this.correct();
    }else {
      this.incorrect();
    }
  }

  incorrect() {
    this.correctAnswer = false;
    this.points = this.points;
    return setTimeout(() => {
      //this.next();
    }, 3000);
  }

  correct() {
    this.correctAnswer = true;
    this.addPoints();
  }

  addPoints() {
    let self = this;
    let i = 0;
    let interval = setInterval( increment, 50);
    function increment() {
      i = i + 1;
      self.points++;
      if (i === 10) {
        clearInterval(interval);
        //self.next();
      }
    }
  }

  animateIn() {
    let self = this;
    this.animateQuestionOut = false;
    return setTimeout(function() {
      self.correctAnswer = false;
      self.renderer.setElementClass(document.body, 'overflow-hide', false);
    }, 500);
  }

  getResults() {
    this.resultsReady = true;
  }

  startQuiz() {
    this.quizReady = true;
    return setTimeout( () => {

    }, 300);
  }

  ngOnInit() {
    this.isReady = true;
    this.questionsService.list();
  }

  shareOnFacebook() {
    let textData = 'I got ' + this.points + ' points do you think you can beat me?';
    window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(location.href) + '&amp;title=' + textData, 'Facebook', 'toolbar=no,width=550,height=550');
    return false;
  }

  shareOnTwitter() {
    let textData = 'I got ' + this.points + ' points do you think you can beat me?';
    window.open('http://twitter.com/share?url=' + encodeURIComponent(location.href) + '&amp;text=' + textData , 'Twitter', 'toolbar=no,width=550,height=550');
    return false;
  }

  reloadPage() {
    location.reload();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/question/question.component.ts